var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFooterFrame(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 178,
    height: 340,
    viewBox: "0 0 178 340",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Frame",
    clipPath: "url(#clip0_496_49725)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M-5.58446 272.286C-2.7285 274.044 -1.53426 278.605 -3.1786 281.472C-4.9369 284.537 -9.79003 285.781 -12.7292 283.92C-15.5661 282.129 -16.7569 277.581 -15.1243 274.696C-13.4014 271.655 -8.59669 270.437 -5.58446 272.286Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M0.603758 247.454C2.24462 244.574 6.73864 243.287 9.76046 244.834C12.8528 246.411 14.2719 251.266 12.5197 254.301C10.8658 257.185 6.35408 258.484 3.34871 256.946C0.285759 255.375 -1.13208 250.499 0.603758 247.454Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M50.2334 175.093C47.3373 173.366 46.086 168.904 47.6671 165.957C49.2767 162.96 54.221 161.614 57.1747 163.375C60.2025 165.178 61.3542 170.021 59.4552 172.949C57.6213 175.784 53.1378 176.825 50.2334 175.093Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M18.8226 229.613C15.7806 227.835 14.5726 222.937 16.4574 220.033C18.2865 217.207 22.8434 216.076 25.7187 217.726C28.7373 219.468 29.9441 224.387 28.0758 227.3C26.2678 230.128 21.659 231.272 18.8226 229.613Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    d: "M34.636 202.432C31.7417 200.816 30.3905 196.318 31.8858 193.31C33.4252 190.207 38.2651 188.757 41.3321 190.473C44.3991 192.189 45.6711 197.014 43.8448 200.006C42.117 202.847 37.5303 204.048 34.636 202.432Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    d: "M104.09 81.7922C107.269 83.5616 108.505 88.1249 106.643 91.2172C104.853 94.1861 100.707 95.1925 97.571 93.4257C94.4641 91.6648 93.158 87.6207 94.7021 84.5094C96.2687 81.3781 100.928 80.0323 104.09 81.7922Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    d: "M81.9244 120.659C78.6423 118.841 77.3426 114.406 79.1987 111.343C80.9373 108.464 85.3437 107.291 88.3569 108.91C91.51 110.609 92.8112 115.232 91.0032 118.344C89.2807 121.309 85.042 122.382 81.9244 120.659Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    d: "M65.964 147.733C62.954 145.918 61.7502 141.659 63.3961 138.694C65.0943 135.639 69.905 134.392 72.9138 136.228C75.9554 138.082 77.0686 142.86 75.1354 145.79C73.2389 148.676 69.007 149.567 65.964 147.733Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    d: "M55.7824 72.3695C58.6295 74.2765 59.5657 78.3154 57.8201 81.1679C55.9985 84.152 51.5384 85.2289 48.624 83.3817C45.632 81.4788 44.6994 77.1678 46.6352 74.1948C48.6456 71.1114 52.6899 70.2989 55.7824 72.3695Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    d: "M40.5322 53.1575C42.1196 50.1041 46.5336 48.8032 49.6031 50.4767C52.5411 52.0742 53.745 56.0483 52.2376 59.1151C50.5947 62.4546 46.6895 63.786 43.4114 62.1128C40.2533 60.4978 38.9055 56.298 40.5322 53.1575Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    d: "M124.703 109.057C121.55 107.226 120.517 103.164 122.412 100.014C124.157 97.1062 128.131 95.9789 131.114 97.5365C134.22 99.1654 135.449 103.439 133.699 106.563C131.925 109.75 127.854 110.876 124.703 109.057Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    d: "M67.8939 68.6586C69.6578 65.6413 74.0664 64.5017 77.0258 66.3091C80.051 68.1544 80.9818 72.3547 79.0514 75.4513C77.1826 78.4411 73.4358 79.4034 70.3852 77.6969C67.2654 75.9396 66.1061 71.7171 67.8939 68.6586Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    d: "M166.493 143.998C164.631 147.014 160.255 148.04 157.339 146.138C154.399 144.221 153.464 139.744 155.397 136.89C157.306 134.077 161.242 133.224 164.222 134.977C167.423 136.858 168.426 140.859 166.493 143.998Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    d: "M139.6 164.212C141.508 161.212 145.764 160.335 148.79 162.313C151.857 164.313 152.689 168.457 150.624 171.465C148.735 174.223 144.578 175.135 141.762 173.422C138.799 171.602 137.748 167.134 139.6 164.212Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    d: "M112.353 148.645C114.184 145.59 118.399 144.613 121.488 146.539C124.42 148.374 125.443 152.244 123.781 155.254C122.092 158.314 117.712 159.537 114.702 157.799C111.683 156.056 110.556 151.644 112.353 148.645Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    d: "M73.6031 90.2255C75.3889 87.0563 79.4437 85.9976 82.629 87.8696C85.6087 89.6228 86.7718 93.4966 85.2164 96.5137C83.6181 99.6048 79.2747 100.935 76.1827 99.2819C73.1119 97.6296 71.8742 93.296 73.6031 90.2255Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    d: "M58.0506 117.163C59.9798 114.087 64.1222 113.2 67.1938 115.192C70.0728 117.063 71.067 121.059 69.3695 123.961C67.6008 126.986 63.1792 128.129 60.2233 126.335C57.2262 124.517 56.1879 120.123 58.0506 117.163Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    d: "M42.2146 108.217C40.4882 111.245 36.0512 112.434 33.0892 110.669C30.0697 108.871 29.0181 104.557 30.8634 101.531C32.6755 98.5639 36.472 97.5535 39.5498 99.2318C42.7345 100.972 43.9742 105.131 42.2146 108.217Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    d: "M152.036 124.816C148.81 123.053 147.737 119.099 149.612 115.871C151.353 112.874 155.178 111.682 158.21 113.192C161.322 114.736 162.644 118.998 161.007 122.176C159.385 125.309 155.183 126.546 152.036 124.816Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    d: "M130.542 130.666C127.484 129.01 126.248 124.655 127.977 121.585C129.63 118.646 133.567 117.487 136.627 119.045C139.909 120.71 141.243 124.726 139.562 127.922C137.933 131.029 133.633 132.341 130.542 130.666Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    d: "M100.921 105.668C102.828 102.613 106.983 101.722 110.068 103.711C112.976 105.588 113.961 109.523 112.245 112.458C110.479 115.497 106.1 116.642 103.115 114.842C100.118 113.024 99.0701 108.646 100.921 105.668Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    d: "M96.5692 139.609C94.8334 142.654 90.4435 143.837 87.4568 142.058C84.4572 140.282 83.3683 135.881 85.2029 132.893C86.9769 129.991 90.8972 128.976 93.9256 130.626C97.1268 132.375 98.3465 136.512 96.5692 139.609Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    d: "M69.3547 160.361C71.0533 157.23 75.2451 156.085 78.3836 157.887C81.3528 159.601 82.5441 163.502 81.0263 166.53C79.4705 169.623 75.1362 171.014 72.0286 169.406C68.9657 167.835 67.6752 163.46 69.3547 160.361Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    d: "M-7.89167 43.1197C-6.05484 39.8812 -2.13803 38.8525 1.06592 40.7682C3.982 42.5176 5.13784 46.442 3.61306 49.4439C2.06454 52.4869 -2.37665 53.816 -5.4345 52.1602C-8.51229 50.4819 -9.66677 46.2512 -7.89167 43.1197Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    d: "M20.5778 113.952C18.7081 117.171 14.7726 118.156 11.5876 116.208C8.69056 114.425 7.57491 110.469 9.14428 107.504C10.7517 104.473 15.2033 103.183 18.2244 104.883C21.2997 106.604 22.394 110.844 20.5778 113.952Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    d: "M63.472 102.416C61.6057 105.649 57.6937 106.669 54.5074 104.742C51.6043 102.989 50.4817 99.0069 52.0628 96.0594C53.7116 92.9756 58.0655 91.6839 61.1044 93.3725C64.2043 95.1074 65.299 99.2708 63.472 102.416Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    d: "M136.186 151.91C132.989 150.02 132.036 146.104 133.99 142.911C135.876 139.833 140.134 138.803 143.074 140.72C145.854 142.533 146.843 146.614 145.208 149.541C143.496 152.621 139.267 153.733 136.186 151.91Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    d: "M107.931 182.689C106.097 185.676 101.643 186.724 98.7556 184.848C95.819 182.945 94.8788 178.476 96.8 175.604C98.6608 172.818 102.715 171.912 105.62 173.623C108.756 175.466 109.817 179.632 107.931 182.689Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    d: "M15.8985 46.228C12.8319 44.4355 11.7037 40.1213 13.517 37.1324C15.3161 34.1683 19.8009 33.1056 22.7153 34.9528C25.5276 36.73 26.5179 40.7892 24.8685 43.7411C23.0706 46.9691 19.0639 48.0775 15.8985 46.228Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    d: "M21.754 67.8463C18.6809 66.1598 17.5243 61.8949 19.3016 58.7975C21.0551 55.7413 24.7542 54.6527 27.8748 56.257C31.0741 57.8957 32.4222 62.0189 30.8037 65.1641C29.2388 68.1976 24.7941 69.5137 21.754 67.8463Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    d: "M15.1257 128.789C17.0033 125.651 21.1002 124.671 24.2051 126.606C27.0598 128.386 28.1513 132.46 26.5563 135.356C24.8806 138.391 20.4575 139.632 17.4506 137.907C14.4026 136.158 13.3051 131.828 15.1257 128.789Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    d: "M4.87386 141.152C3.00413 144.371 -0.900642 145.341 -4.09858 143.396C-7.00041 141.622 -8.11733 137.687 -6.5432 134.714C-4.94406 131.678 -0.545603 130.423 2.51446 132.113C5.58749 133.799 6.69483 138.036 4.87386 141.152Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    d: "M27.6147 89.2264C24.4734 87.5443 23.1939 83.3401 24.8899 80.2507C26.5479 77.227 31.0134 75.9887 34.0026 77.7255C36.8766 79.3958 38.0144 83.4085 36.4636 86.4173C34.7666 89.7365 30.8842 90.9715 27.6147 89.2264Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    d: "M135.113 198.349C133.28 201.37 128.885 202.43 125.977 200.553C123.035 198.658 122.074 194.188 123.982 191.319C125.83 188.537 129.894 187.615 132.809 189.309C135.949 191.144 137.001 195.249 135.113 198.349Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    d: "M42.2757 144.486C44.1214 141.384 48.2831 140.387 51.3728 142.292C54.2405 144.068 55.3381 148.113 53.7336 151.025C52.0566 154.081 47.6676 155.32 44.6478 153.598C41.6361 151.881 40.4871 147.489 42.2757 144.486Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    d: "M47.7476 129.671C45.8566 132.889 41.9519 133.859 38.7799 131.907C35.8746 130.12 34.7849 126.157 36.3906 123.224C38.0594 120.162 42.4414 118.898 45.4448 120.61C48.5023 122.342 49.572 126.568 47.7476 129.671Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    d: "M117.267 216.57C120.344 218.478 121.284 222.662 119.324 225.697C117.513 228.491 113.396 229.524 110.533 227.893C107.521 226.176 106.35 221.727 108.128 218.762C109.916 215.759 114.281 214.714 117.267 216.57Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    d: "M63.5607 309.498C60.4946 307.837 59.2418 303.473 60.9551 300.448C62.6637 297.432 67.1042 296.256 70.0826 298.03C72.9212 299.724 74.0634 303.805 72.52 306.763C70.8566 309.948 66.7255 311.215 63.5607 309.498Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    d: "M47.8554 336.643C44.7495 334.937 43.5305 330.647 45.2745 327.607C46.9996 324.6 51.4648 323.439 54.4125 325.228C57.2415 326.938 58.3578 331.027 56.8027 333.967C55.1202 337.185 51.0518 338.4 47.8554 336.643Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    d: "M20.4411 320.815C17.3982 318.982 16.3362 314.629 18.2222 311.704C20.0241 308.906 24.1473 307.843 27.0264 309.428C30.0453 311.094 31.2415 315.481 29.5022 318.512C27.7284 321.623 23.5416 322.682 20.4411 320.815Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    d: "M109.035 136.234C105.815 134.365 104.833 130.463 106.769 127.261C108.641 124.152 112.849 123.094 115.824 124.987C118.628 126.76 119.64 130.82 117.995 133.764C116.231 136.934 112.18 138.061 109.035 136.234Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    d: "M86.5582 188.29C84.7666 191.413 80.672 192.426 77.5269 190.523C74.5251 188.713 73.498 184.983 75.142 181.908C76.8051 178.799 81.0777 177.515 84.12 179.217C87.1424 180.896 88.307 185.242 86.5582 188.29Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    d: "M-9.13708 296.314C-7.42593 293.255 -3.05944 292.036 -0.0538142 293.782C2.95181 295.529 4.07839 299.941 2.27802 302.926C0.571363 305.768 -3.49418 306.864 -6.45461 305.287C-9.63016 303.607 -10.8767 299.422 -9.13708 296.314Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M26.4422 171.93C28.129 168.78 32.2904 167.575 35.4315 169.333C38.5232 171.063 39.7032 175.364 37.9345 178.389C36.275 181.226 32.1654 182.417 29.1952 180.933C26.1344 179.396 24.7933 175.013 26.4422 171.93Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M20.7257 150.337C22.4356 147.299 26.8008 146.102 29.8146 147.853C32.8367 149.608 33.8709 153.858 32.0183 156.933C30.1942 159.96 26.5261 160.957 23.4271 159.277C20.2576 157.568 18.9968 153.407 20.7257 150.337Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M-0.611272 156.047C1.22395 152.906 5.34233 151.851 8.44156 153.739C11.4468 155.562 12.5051 159.979 10.6414 162.884C8.84906 165.665 4.68829 166.718 1.81393 165.124C-1.24138 163.426 -2.39078 159.11 -0.611272 156.047Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M3.6319 85.9189C5.50731 82.7466 9.51935 81.7619 12.6701 83.7126C15.546 85.4937 16.6461 89.4956 15.0651 92.4431C13.4507 95.4481 8.95326 96.7227 5.97104 95.0119C2.91827 93.2713 1.81822 88.9843 3.6319 85.9189Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M-12.192 113.346C-10.44 110.102 -6.44373 108.955 -3.24639 110.768C-0.155972 112.52 1.02886 116.812 -0.756327 119.828C-2.41457 122.643 -6.57128 123.84 -9.5156 122.349C-12.6032 120.763 -13.8906 116.478 -12.192 113.346Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M0.225408 73.4131C-2.85899 71.6323 -4.00491 67.3298 -2.19632 64.3492C-0.410205 61.3885 4.12299 60.299 6.99158 62.1306C9.81905 63.9385 10.8167 67.9471 9.18368 70.9084C7.39747 74.1542 3.42495 75.2603 0.225408 73.4131Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M-11.1204 30.6285C-14.2276 28.9442 -15.4985 24.6682 -13.7874 21.6094C-12.1047 18.6 -7.63697 17.3959 -4.6573 19.1491C-1.79753 20.8441 -0.661018 24.878 -2.20225 27.8704C-3.88246 31.1225 -7.90977 32.3616 -11.1204 30.6285Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M120.731 179.21C117.445 177.456 116.319 173.592 118.144 170.336C119.911 167.2 124.128 165.994 127.128 167.769C129.976 169.447 131.125 173.477 129.625 176.493C128.074 179.655 123.921 180.921 120.731 179.21Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M93.2377 163.348C90.0467 161.429 89.131 157.545 91.1267 154.354C92.9384 151.463 96.8919 150.39 99.8122 151.999C102.856 153.679 104.013 158 102.247 161.059C100.425 164.197 96.3629 165.229 93.2377 163.348Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M16.4831 183.803C14.706 187.109 10.8806 188.246 7.63267 186.425C4.50808 184.676 3.30518 180.472 5.06917 177.455C6.73818 174.602 10.7617 173.427 13.7614 174.917C16.9303 176.495 18.1889 180.621 16.4831 183.803Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M89.3614 233.6C86.0508 231.832 84.9098 228.014 86.7267 224.753C88.4771 221.608 92.6503 220.42 95.684 222.193C98.5533 223.872 99.7347 227.866 98.2476 230.879C96.6893 234.015 92.5404 235.293 89.3614 233.6Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M111.383 194.946C114.376 196.674 115.529 201.079 113.763 204.063C111.973 207.087 107.752 208.072 104.683 206.19C101.679 204.346 100.724 200.68 102.43 197.574C104.149 194.444 108.351 193.207 111.383 194.946Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M87.9592 280.003C86.0775 282.996 81.6909 283.983 78.8027 282.053C76.0331 280.202 75.0349 276.061 76.6733 273.223C78.4065 270.221 82.8103 269.09 85.8052 270.874C88.8117 272.675 89.8361 277.017 87.9592 280.003Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M53.7395 187.427C55.5095 184.38 59.8035 183.306 62.8287 185.151C65.6859 186.888 66.8129 190.939 65.2414 193.87C63.602 196.937 59.2365 198.211 56.1976 196.523C53.167 194.839 51.9837 190.449 53.7395 187.427Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M80.8014 203.314C82.4373 200.233 86.7449 199.003 89.8237 200.736C92.7543 202.385 93.9855 206.331 92.51 209.361C91.0001 212.47 86.6974 213.901 83.5709 212.326C80.5184 210.794 79.1608 206.402 80.8014 203.314Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M41.989 315.215C38.9479 313.492 37.8877 309.25 39.7191 306.173C41.5362 303.121 45.1585 302.108 48.2882 303.773C51.4672 305.466 52.7505 309.606 51.0558 312.674C49.3753 315.718 45.0088 316.937 41.989 315.215Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M-8.09943 213.598C-11.2227 211.828 -12.3962 207.63 -10.6158 204.622C-8.84485 201.631 -4.48726 200.56 -1.49843 202.374C1.40815 204.14 2.41466 208 0.764898 211.028C-1.01563 214.321 -4.87394 215.438 -8.09943 213.598Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M22.1825 205.672C20.3575 208.643 15.8869 209.681 13.0032 207.818C10.0536 205.918 9.11434 201.504 11.045 198.616C12.8975 195.825 16.9931 194.867 19.8576 196.554C22.8689 198.347 23.9933 202.725 22.1825 205.672Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M23.8273 296.943C22.142 299.995 17.8037 301.241 14.7921 299.524C11.751 297.801 10.6861 293.567 12.514 290.477C14.3134 287.437 17.9663 286.409 21.0796 288.064C24.3045 289.772 25.5552 293.817 23.8273 296.943Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M82.4711 258.223C80.8128 261.324 76.6456 262.482 73.5011 260.71C70.4142 258.972 69.3041 255.348 70.8966 252.21C72.5569 248.935 76.521 247.616 79.6978 249.275C82.8171 250.9 84.1247 255.131 82.4711 258.223Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M42.6637 282.211C45.7146 283.841 46.9509 288.196 45.235 291.263C43.6189 294.157 39.5963 295.388 36.5871 293.913C33.4662 292.386 32.0599 288.097 33.643 284.976C35.2057 281.908 39.6011 280.563 42.6637 282.211Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M103.806 252.555C102.072 255.634 97.7682 256.801 94.7521 255.016C91.7607 253.245 90.6497 248.787 92.4674 245.867C94.2092 243.078 98.3171 241.984 101.245 243.543C104.345 245.201 105.557 249.465 103.806 252.555Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M66.6471 285.651C64.8679 288.637 60.4891 289.706 57.5263 287.886C54.4976 286.028 53.5854 281.871 55.5358 278.797C57.421 275.817 61.0922 274.909 64.1696 276.664C67.2917 278.456 68.4405 282.639 66.6471 285.651Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M-2.52684 235.097C-5.54637 233.299 -6.61316 228.955 -4.7704 225.972C-2.92764 222.989 1.49447 221.978 4.39341 223.871C7.16551 225.68 8.18838 229.834 6.57474 232.686C4.87435 235.707 0.459786 236.876 -2.52684 235.097Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M39.2992 270.069C37.4257 273.067 33.1181 274.013 30.1876 272.08C27.1877 270.096 26.4085 265.994 28.4376 262.954C30.3873 260.033 34.0734 259.233 37.1163 261.067C40.2497 262.952 41.2283 266.994 39.2992 270.069Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M43.9543 236.04C45.8436 232.92 49.8851 231.941 52.9653 233.862C55.8118 235.637 56.8401 239.631 55.2084 242.571C53.4804 245.697 49.3807 246.795 46.2387 244.981C43.0357 243.121 42.0365 239.21 43.9543 236.04Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M62.1039 217.863C58.8322 216.084 57.7197 212.217 59.56 208.992C61.3385 205.873 65.5269 204.716 68.5299 206.505C71.385 208.208 72.5227 212.221 70.9746 215.187C69.3004 218.41 65.3133 219.617 62.1039 217.863Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M9.04459 278.023C5.98835 276.269 4.86143 271.934 6.67129 268.932C8.4764 265.939 12.9153 264.86 15.8168 266.711C18.6079 268.487 19.671 272.61 18.0889 275.502C16.4237 278.576 12.0926 279.772 9.04459 278.023Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M76.6418 236.883C74.906 239.928 70.542 241.104 67.5554 239.325C64.5558 237.549 63.4564 233.109 65.2919 230.177C67.0384 227.38 71.1416 226.294 74.0644 227.861C77.1482 229.51 78.3824 233.83 76.6418 236.883Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M49.5783 257.394C51.3986 254.431 55.8609 253.388 58.7529 255.255C61.7025 257.156 62.643 261.548 60.7193 264.462C58.8892 267.233 54.7595 268.193 51.8984 266.52C48.8811 264.756 47.7628 260.348 49.5783 257.394Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M38.0595 214.586C39.8482 211.583 44.2365 210.497 47.1769 212.337C50.1584 214.201 51.1743 218.615 49.286 221.506C47.4819 224.27 43.3224 225.301 40.4705 223.687C37.4459 221.974 36.2756 217.581 38.0595 214.586Z",
    fill: "#8F1C26"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M22.2509 241.967C23.9149 238.914 28.2697 237.677 31.306 239.409C34.3259 241.13 35.4784 245.535 33.6957 248.509C31.9986 251.334 27.908 252.493 24.9697 250.972C21.8868 249.379 20.5774 245.037 22.2509 241.967Z",
    fill: "#8F1C26"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_496_49725"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 248.843,
    height: 248.748,
    fill: "white",
    transform: "translate(177.844 124.374) rotate(120)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterFrame);
export default __webpack_public_path__ + "static/media/footer-frame.a31ab5cdda8d7e88a8647a7846f512b3.svg";
export { ForwardRef as ReactComponent };